import PropTypes from "prop-types";
import React from "react";
import ApprovedIcon from "../../../../assets/assets/nip-approved.svg";
import Button from "../../../Button/Button";

const Approved = (props) => {
  const { goToNext } = props;

  return (
    <div>
      <div className="nip-integration-header">Document Upload</div>

      <div className="doc-pending">
        <div className="middle-box">
          <div className="middle-box-image2">
            <img src={ApprovedIcon} alt="approved icon" />
          </div>
          <div className="middle-box-title">Documents Approved</div>
          <span className="middle-box-subtitle">
            Your documents have been approved. You can now proceed <br /> to the
            next step
          </span>

          <Button
            type="submit"
            width="50%"
            testId="goToNext"
            height="50px"
            text="PROCEED"
            onClick={() => goToNext()}
          />
        </div>
      </div>
    </div>
  );
};

Approved.propTypes = {
  goToNext: PropTypes.func,
};

export default Approved;
